import { AlertDialogBody, AlertDialogFooter } from '@chakra-ui/react'

import {
  Box as DarkBox,
  Button as DarkButton,
  Modal as DarkModal,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { BasicAlertDialog, Button } from '@/components/ui'

interface SaveGridConfirmDialogIProps {
  colorScheme?: ColorScheme
  isOpen: boolean
  isSaving: boolean
  onCancel: () => void
  onConfirm: () => void
  zIndex?: number
}

export const SaveGridConfirmDialog = ({
  colorScheme,
  isOpen,
  isSaving,
  onCancel,
  onConfirm,
  zIndex = 1100,
}: SaveGridConfirmDialogIProps) => {
  const body = (
    <>
      This will replace the current grid configuration for this camera with the
      one you just tested. This action cannot be undone.
    </>
  )

  if (colorScheme) {
    return (
      <DarkModal
        colorScheme={colorScheme}
        footer={
          <>
            <DarkButton
              colorScheme={colorScheme}
              onClick={onCancel}
              variant='tertiary'
            >
              Cancel
            </DarkButton>
            <DarkButton
              colorScheme={colorScheme}
              disabled={isSaving}
              isLoading={isSaving}
              onClick={onConfirm}
              variant='primary'
            >
              Save Grid
            </DarkButton>
          </>
        }
        isOpen={isOpen}
        isSaveHidden
        onClose={onCancel}
        size='compact'
        title='Save New Camera Grid?'
        zIndex={zIndex}
      >
        <DarkBox>{body}</DarkBox>
      </DarkModal>
    )
  }

  return (
    <BasicAlertDialog
      isCentered
      isOpen={isOpen}
      onClose={onCancel}
      title='Save New Camera Grid?'
    >
      <AlertDialogBody>{body}</AlertDialogBody>
      <AlertDialogFooter>
        <Button mr={3} onClick={onCancel} variant='secondary'>
          Cancel
        </Button>
        <Button isDisabled={isSaving} onClick={onConfirm}>
          Save Grid
        </Button>
      </AlertDialogFooter>
    </BasicAlertDialog>
  )
}
